import { render, staticRenderFns } from "./HeadShow.vue?vue&type=template&id=3dfa38b2&scoped=true&"
import script from "./HeadShow.vue?vue&type=script&lang=js&"
export * from "./HeadShow.vue?vue&type=script&lang=js&"
import style0 from "./HeadShow.vue?vue&type=style&index=0&id=3dfa38b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfa38b2",
  null
  
)

export default component.exports